import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { twMerge } from 'tailwind-merge'

export const PlayerError = ({ videoURL, className }) => (
	<div className={twMerge('flex items-center flex-col justify-center w-full h-full border-2 border-pink rounded-lg', className)}>
		<WarningAmberOutlinedIcon fontSize="large" className="!fill-pink" />
		<p className="text-lg text-pink text-center mt-2">
			Video failed to load
		</p>
		{videoURL && (
			<a
				href={videoURL}
				target="_blank"
				rel="noopener noreferrer"
				className="text-sm text-teal underline mt-2"
			>
				Watch on the original platform
			</a>
		)}
	</div>
)
